<section class="schedule-page">
  <header class="schedule-header">
    <img src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" class="brand-logo" />
    <div class="title-strip">
      <button type="button" class="back-btn" (click)="goBack()" aria-label="Back to maintenance">&#8592;</button>
      <h1>Schedule Maintenance</h1>
    </div>
  </header>

  <p class="message" *ngIf="loadingPart">Loading maintenance details...</p>
  <p *ngIf="!loadingPart && errorMessage" class="message error">{{ errorMessage }}</p>
  <p *ngIf="!loadingPart && !errorMessage && successMessage" class="message success">{{ successMessage }}</p>

  <main class="schedule-layout" *ngIf="!loadingPart && selectedPart as part">
    <section class="part-panel">
      <div class="part-header">
        <img [src]="partIcon(part.name)" alt="Maintenance part icon" class="part-icon" />

        <div class="part-details">
          <h2>Part Name: {{ part.name }}</h2>
          <p>Durability: {{ part.durabilityPercent }}%</p>
          <p *ngIf="part.cost !== null; else missingCost">Cost: ${{ part.cost }}</p>
          <ng-template #missingCost><p>Cost: Not recorded</p></ng-template>
        </div>
      </div>

      <div class="history-grid">
        <div class="head">History</div>
        <div class="head">Mechanic</div>
        <div class="head">Status</div>

        <ng-container *ngFor="let row of part.history">
          <div>{{ row.monthLabel }}</div>
          <div>{{ row.mechanic }}</div>
          <div>{{ row.status }}</div>
        </ng-container>
      </div>

      <p class="mechanic-row">
        Select Mechanic:
        <button type="button" class="link-button" (click)="openMechanics()">{{ selectedMechanicLabel }}</button>
      </p>
    </section>

    <section class="planner-panel">
      <div class="calendar-shell">
        <div class="calendar-nav">
          <button type="button" class="calendar-nav-btn" (click)="onPrevMonth()" aria-label="Previous month">&#8249;</button>
          <select
            class="calendar-select"
            [ngModel]="calendarMonth"
            (ngModelChange)="onCalendarMonthChange($event)">
            <option *ngFor="let month of monthOptions" [ngValue]="month.value">{{ month.label }}</option>
          </select>
          <select
            class="calendar-select"
            [ngModel]="calendarYear"
            (ngModelChange)="onCalendarYearChange($event)">
            <option *ngFor="let year of calendarYearOptions" [ngValue]="year">{{ year }}</option>
          </select>
          <button type="button" class="calendar-nav-btn" (click)="onNextMonth()" aria-label="Next month">&#8250;</button>
        </div>

        <div class="calendar-weekdays">
          <span *ngFor="let weekday of weekdayLabels">{{ weekday }}</span>
        </div>

        <div class="calendar-days">
          <button
            *ngFor="let cell of calendarCells"
            type="button"
            class="calendar-day"
            [class.outside]="!cell.inCurrentMonth"
            [class.selected]="cell.isSelected"
            [disabled]="!cell.inCurrentMonth"
            (click)="onSelectCalendarDay(cell)">
            {{ cell.dayNumber }}
          </button>
        </div>
      </div>

      <div class="planner-bottom">
        <div class="time-grid">
          <div class="time-card">
            <h3>From</h3>
            <div class="time-row">
              <input type="text" maxlength="2" [(ngModel)]="fromHour" />
              <span>:</span>
              <input type="text" maxlength="2" [(ngModel)]="fromMinute" />
              <select [(ngModel)]="fromPeriod">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>

          <div class="time-card">
            <h3>To</h3>
            <div class="time-row">
              <input type="text" maxlength="2" [(ngModel)]="toHour" />
              <span>:</span>
              <input type="text" maxlength="2" [(ngModel)]="toMinute" />
              <select [(ngModel)]="toPeriod">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>

        <div class="actions">
          <button type="button" class="btn schedule-btn" (click)="schedule()" [disabled]="submitting">Schedule</button>
          <button type="button" class="btn cancel-btn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </section>
  </main>
</section>
